import { render, staticRenderFns } from "./FileTypes.vue?vue&type=template&id=0e9232ba&"
import script from "./FileTypes.vue?vue&type=script&lang=js&"
export * from "./FileTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports